// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group-control{position:absolute;right:2%;top:2%;z-index:99}\n", "",{"version":3,"sources":["webpack://./src/styles/group-control.scss"],"names":[],"mappings":"AAAA,eACE,iBAAkB,CAClB,QAAS,CACT,MAAO,CACP,UAAW","sourcesContent":[".group-control {\n  position: absolute;\n  right: 2%;\n  top: 2%;\n  z-index: 99;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
